import React, { Component } from "react";
import { connect } from "react-redux";
import { Link } from "react-router-dom";

import { act_login, act_logout } from "../../redux/actions";
import queryString from "query-string";

import {
  Card,
  Form,
  Button,
  Input,
  message,
  Modal,
  BackTop,
  Image,
  Avatar,
  Tag,
  Divider,
  Alert,
} from "antd";
import VideoPlayer from "react-video-js-player";
import {
  LockOutlined,
  UserOutlined,
  ExclamationCircleOutlined,
} from "@ant-design/icons";

import { formateDate } from "../../utils/dateUtil";
import {
  loadCaptchaEnginge,
  LoadCanvasTemplateNoReload,
  validateCaptcha,
} from "react-simple-captcha";
import {
  req_list_eps_activity_public,
  req_list_eps_deeds_public,
  req_list_eps_license_public,
  req_list_eps_teacher_master_open,
  req_list_eps_student_master_open,
  req_single_eps_works_hot_open,
  req_single_eps_blogger_open,
  req_single_eps_bloggerlinks_open,
  req_single_eps_degreeLicense_open,
  req_single_eps_deeds_open,
  req_single_eps_openCourse_open,
  req_single_eps_learnedcourse_open,
  req_single_eps_activity_join_open,
  req_single_eps_activity_hold_open,
  req_single_eps_works_open,
  req_single_eps_deeds_customize_open,
  req_single_eps_club_open,
} from "../../api";

import { API_BASE } from "../../utils/contrains";
import "./blog.css";
const Item = Form.Item;
const { Meta } = Card;

class Blog extends Component {
  state = {
    item: {},
    isBlogger: false,
    links: [],
    clubs: [],

    licenses: [],
    deeds: [],
    deedsgrouped: [],
    opencourses: [],
    learnedcourses: [],
    joinactivities: [],
    holdactivities: [],
    works: [],

    publicactivities: [],
    publicdeedsteacher: [],
    publicdeedsteachergrouped: [],
    publicdeedsstudent: [],
    publiclicensesteacher: [],
    publiclicensesstudent: [],

    topdissertations: [],
    topjournals: [],
    topbooks: [],
    toppatents: [],
    topprojects: [],
    topawardeds: [],
    topxhibitions: [],

    topdeeds: [],
    toplicenses: [],
    topobjects: [],

    hotworks: [],

    Menu: [],
    BloggerCode: null,
    BlogType: "STUDENT",
    BlogStatus: "ON",
  };

  UNSAFE_componentWillMount() {
    const parsed = queryString.parse(window.location.search);
    const { id } = parsed;

    if (id) {
      // 取得個人部落格 取不到則公版資訊
      //console.log(id)
      this.api_single_item(id);
    } else {
      // 南應大公版(統計類)
      this.api_public_items();
    }
  }

  componentDidMount() {
    this.check_user();
  }

  componentWillUnmount() {
    this.props.act_logout();
  }

  // 遠端數據處理 //////////////////////////////////////////////
  // 有ID
  api_single_item = async (id) => {
    this.setState({ loading: true });
    const item = await req_single_eps_blogger_open(id);
    const isBlogger = item ? true : false;

    if (isBlogger) {
      //確認是否為博主
      const { BloggerCode, BlogType, BlogStatus, DBCustomizeStatus } = item;
      const Menu = item.Menu.data;
      //console.log(item.DBCustomizeStatus);
      this.setState({
        loading: false,
        item,
        isBlogger,
        Menu,
        BloggerCode,
        BlogType,
        BlogStatus,
      });
      if (BlogStatus === "ON") {
        const linksdata = await req_single_eps_bloggerlinks_open(id);
        if (linksdata.data !== null) {
          const links = linksdata.data;
          this.setState({ links });
        }

        const licensedata = await req_single_eps_degreeLicense_open(id);
        if (licensedata.data !== null) {
          const licenses = licensedata.data;
          this.setState({ licenses });
        }
        // 相關經歷
        const deeddata =
          DBCustomizeStatus === "OFF"
            ? await req_single_eps_deeds_open(id)
            : await req_single_eps_deeds_customize_open(id);
        //console.log(deeddata)
        if (deeddata.data !== null) {
          const deeds = deeddata.data;
          let deedsgrouped = deeds.reduce((r, a) => {
            //console.log("a", a);
            //console.log('r', r);
            r[a.SubCategoryName] = [...(r[a.SubCategoryName] || []), a];
            return r;
          }, {});
          // console.log(deedsgrouped);
          this.setState({ deeds, deedsgrouped });
        }

        const activityjoindata = await req_single_eps_activity_join_open(id);
        if (activityjoindata.data !== null) {
          const joinactivities = activityjoindata.data;
          this.setState({ joinactivities });
        }

        if (BlogType === "TEACHER") {
          const activityholddata = await req_single_eps_activity_hold_open(id);
          if (activityholddata.data !== null) {
            const holdactivities = activityholddata.data;
            this.setState({ holdactivities });
          }
          const coursedata = await req_single_eps_openCourse_open(id);
          if (coursedata.data !== null) {
            const opencourses = coursedata.data;
            this.setState({ opencourses });
          }
        } else {
          const coursedata = await req_single_eps_learnedcourse_open(id);
          if (coursedata.data !== null) {
            const learnedcourses = coursedata.data;
            this.setState({ learnedcourses });
          }
          const clubsdata = await req_single_eps_club_open(id);
          if (clubsdata.total > 0) {
            const clubs = clubsdata.data;
            this.setState({ clubs });
          }
          //console.log(clubsdata);
        }

        const worksdata = await req_single_eps_works_open(id);
        if (worksdata.data !== null) {
          const works = worksdata.data;
          this.setState({ works });
          //console.log(works)
        }
      } else {
        this.setState({ loading: false, isBlogger });
      }
    } else {
      this.setState({ loading: false, isBlogger });
    }
  };
  // 無ID
  api_public_items = async () => {
    // 公開頁
    const publicactivitiesdata = await req_list_eps_activity_public();
    if (publicactivitiesdata.data !== null) {
      const publicactivities = publicactivitiesdata.data;
      this.setState({ publicactivities });
    }

    const publicdeedsteacherdata = await req_list_eps_deeds_public("TEACHER");
    if (publicdeedsteacherdata.data !== null) {
      const publicdeedsteacher = publicdeedsteacherdata.data;
      let publicdeedsteachergrouped = publicdeedsteacher.reduce((r, a) => {
        //console.log("a", a);
        //console.log('r', r);
        r[a.SubCategoryName] = [...(r[a.SubCategoryName] || []), a];
        return r;
      }, {});
      this.setState({ publicdeedsteacher, publicdeedsteachergrouped });
    }

    const publicdeedsstudentdata = await req_list_eps_deeds_public("STUDENT");
    if (publicdeedsstudentdata.data !== null) {
      const publicdeedsstudent = publicdeedsstudentdata.data;
      this.setState({ publicdeedsstudent });
    }

    const publiclicensesteacherdata = await req_list_eps_license_public(
      "TEACHER"
    );
    if (publiclicensesteacherdata.data !== null) {
      const publiclicensesteacher = publiclicensesteacherdata.data;
      this.setState({ publiclicensesteacher });
    }

    const publiclicensesstudentdata = await req_list_eps_license_public(
      "STUDENT"
    );
    if (publiclicensesstudentdata.data !== null) {
      const publiclicensesstudent = publiclicensesstudentdata.data;
      this.setState({ publiclicensesstudent });
    }

    // teacher
    const dissertationsdata = await req_list_eps_teacher_master_open(
      "DISSERTATION"
    );
    if (dissertationsdata.data !== null) {
      const topdissertations = dissertationsdata.data;
      this.setState({ topdissertations });
    }
    const journalsdata = await req_list_eps_teacher_master_open("JOURNALS");
    if (journalsdata.data !== null) {
      const topjournals = journalsdata.data;
      this.setState({ topjournals });
    }
    const booksdata = await req_list_eps_teacher_master_open("BOOK");
    if (booksdata.data !== null) {
      const topbooks = booksdata.data;
      this.setState({ topbooks });
    }
    const patentsdata = await req_list_eps_teacher_master_open("PATENT");
    if (patentsdata.data !== null) {
      const toppatents = patentsdata.data;
      this.setState({ toppatents });
    }
    const projectsdata = await req_list_eps_teacher_master_open("PROJECT");
    if (projectsdata.data !== null) {
      const topprojects = projectsdata.data;
      this.setState({ topprojects });
    }
    const awardedsdata = await req_list_eps_teacher_master_open("AWARDED");
    if (awardedsdata.data !== null) {
      const topawardeds = awardedsdata.data;
      this.setState({ topawardeds });
    }
    const xhibitionsdata = await req_list_eps_teacher_master_open("XHIBITION");
    if (xhibitionsdata.data !== null) {
      const topxhibitions = xhibitionsdata.data;
      this.setState({ topxhibitions });
    }

    // student
    const deedsdata = await req_list_eps_student_master_open("DEEDS");
    if (deedsdata.data !== null) {
      const topdeeds = deedsdata.data;
      this.setState({ topdeeds });
    }
    const licensesdata = await req_list_eps_student_master_open("LICENSES");
    if (licensesdata.data !== null) {
      const toplicenses = licensesdata.data;
      this.setState({ toplicenses });
    }
    const objectsdata = await req_list_eps_student_master_open("OBJECTS");
    if (objectsdata.data !== null) {
      const topobjects = objectsdata.data;
      this.setState({ topobjects });
    }

    const hotworksdata = await req_single_eps_works_hot_open();
    //console.log('hotworksdata', hotworksdata)
    if (hotworksdata.data !== null) {
      const hotworks = hotworksdata.data;
      this.setState({ hotworks });
    }
  };

  check_user = () => {
    const user = this.props.user;
    if (!user.token) {
      loadCaptchaEnginge(4, "purple", "white", "numbers");
    }
  };

  // 參數配置 //////////////////////////////////////////////
  findConfigValue = (DownItemCode) => {
    const { Menu } = this.state;
    //  console.log('Menu', Menu)
    let result = "OFF";
    if (Menu) {
      result = Menu.filter((x) => x.DownItemCode === DownItemCode)
        .map((x) => x.ShowStatus)
        .join();
    }
    return result;
  };

  style_switch_color_tag(column, type) {
    let ans = "black";
    switch (type) {
      case "joinactivity":
        switch (column) {
          case "NOTSTART":
            ans = "gray";
            break;
          case "APPLYSTART":
            ans = "orange";
            break;
          case "APPLYEND":
            ans = "purple";
            break;
          case "APPLYFULL":
            ans = "red";
            break;
          case "ACTIVITYSTART":
            ans = "blue";
            break;
          case "ACTIVITYEND":
            ans = "black";
            break;
          default:
            ans = "black";
            break;
        }
        break;
      case "holdactivity":
        switch (column) {
          case "NOTSTART":
            ans = "gray";
            break;
          case "APPLYSTART":
            ans = "orange";
            break;
          case "APPLYEND":
            ans = "purple";
            break;
          case "APPLYFULL":
            ans = "red";
            break;
          case "ACTIVITYSTART":
            ans = "blue";
            break;
          case "ACTIVITYEND":
            ans = "black";
            break;
          default:
            ans = "black";
            break;
        }
        break;
      case "LICENSE":
        switch (column) {
          case "BOTH":
            ans = "olive";
            break;
          case "BYNCSA":
            ans = "sienna";
            break;
          case "COPYRIGHT":
            ans = "goldenRod";
            break;
          default:
            // OTHER
            break;
        }
        break;
      case "TYPE":
        switch (column) {
          case "OTHER":
            ans = "magenta";
            break;
          case "2D":
            ans = "darkSlateBlue";
            break;
          case "3D":
            ans = "indigo";
            break;
          default:
            // OTHER
            break;
        }
        break;
      case "ORIGINAL":
        switch (column) {
          case "BOTH":
            ans = "plum";
            break;
          case "NO":
            ans = "steelBlue";
            break;
          case "YES":
            ans = "darkOrange";
            break;
          default:
            // OTHER
            break;
        }
        break;
      case "PUBLIC":
        switch (column) {
          case "NO":
            ans = "dimGray";
            break;
          case "YES":
            ans = "green";
            break;
          default:
            // OTHER
            break;
        }
        break;
      case "degree":
        switch (column) {
          case "education":
            ans = "blue";
            break;
          case "license":
            ans = "green";
            break;
          default:
            // OTHER
            break;
        }
        break;
      case "deed":
        switch (column) {
          case "dissertation":
            ans = "red";
            break;
          case "journals":
            ans = "orange";
            break;
          case "book":
            ans = "blue";
            break;
          case "patent":
            ans = "black";
            break;
          case "project":
            ans = "blue";
            break;
          case "awarded":
            ans = "yellow";
            break;
          case "xhibition":
            ans = "pink";
            break;
          case "service":
            ans = "green";
            break;
          case "deeds":
            ans = "gold";
            break;

          default:
            // OTHER
            break;
        }
        break;
      case "deedgrouds":
        switch (column) {
          case "論文":
            ans = "red";
            break;
          case "期刊":
            ans = "orange";
            break;
          case "專書":
            ans = "blue";
            break;
          case "專利":
            ans = "pink";
            break;
          case "展演":
            ans = "blue";
            break;
          case "獲獎":
            ans = "yellow";
            break;
          case "事蹟":
            ans = "black";
            break;
          case "服務":
            ans = "green";
            break;
          case "計畫案":
            ans = "gold";
            break;

          default:
            // OTHER
            break;
        }
        break;
      case "selecttype":
        switch (column) {
          case "必修 ":
            ans = "Indigo";
            break;
          case "選修 ":
            ans = "DarkOrchid";
            break;
          default:
            // OTHER
            break;
        }
        break;
      case "awardlevel":
        switch (column) {
          case 1:
            ans = "Gold";
            break;
          case 2:
            ans = "Silver";
            break;
          case 3:
            ans = "	Tan";
            break;
          default:
            // OTHER
            break;
        }
        break;
      case "timeTag":
        switch (column) {
          case "ACTIVITYSTART":
            ans = "GREEN";
            break;
          case "APPLYSTART":
            ans = "RED";
            break;
          default:
            // OTHER
            break;
        }
        break;
      default:
        ans = "black";
        break;
    }
    return ans;
  }

  style_switch_text_tag(column, type) {
    let ans = "未知狀態";
    switch (type) {
      case "joinactivity":
        switch (column) {
          case "NOTSTART":
            ans = "尚未開放";
            break;
          case "APPLYSTART":
            ans = "報名開始";
            break;
          case "APPLYEND":
            ans = "報名結束";
            break;
          case "APPLYFULL":
            ans = "報名額滿";
            break;
          case "ACTIVITYSTART":
            ans = "活動開始";
            break;
          case "ACTIVITYEND":
            ans = "活動結束";
            break;
          default:
            ans = "未知狀態";
            break;
        }
        break;
      case "holdactivity":
        switch (column) {
          case "NOTSTART":
            ans = "尚未開放";
            break;
          case "APPLYSTART":
            ans = "報名開始";
            break;
          case "APPLYEND":
            ans = "報名結束";
            break;
          case "APPLYFULL":
            ans = "報名額滿";
            break;
          case "ACTIVITYSTART":
            ans = "活動開始";
            break;
          case "ACTIVITYEND":
            ans = "活動結束";
            break;
          default:
            ans = "未知狀態";
            break;
        }
        break;
      case "LICENSE":
        switch (column) {
          case "BOTH":
            ans = "無限制";
            break;
          case "BYNCSA":
            ans = "非商業性分享";
            break;
          case "COPYRIGHT":
            ans = "版權所有";
            break;
          default:
            // OTHER
            break;
        }
        break;
      case "TYPE":
        switch (column) {
          case "OTHER":
            ans = "其它";
            break;
          case "2D":
            ans = "平面";
            break;
          case "3D":
            ans = "立體";
            break;
          default:
            // OTHER
            break;
        }
        break;
      case "ORIGINAL":
        switch (column) {
          case "BOTH":
            ans = "其它";
            break;
          case "NO":
            ans = "非原創";
            break;
          case "YES":
            ans = "原創";
            break;
          default:
            // OTHER
            break;
        }
        break;
      case "PUBLIC":
        switch (column) {
          case "NO":
            ans = "關閉瀏覽";
            break;
          case "YES":
            ans = "開放瀏覽";
            break;
          default:
            // OTHER
            break;
        }
        break;
      case "timeTag":
        switch (column) {
          case "ACTIVITYSTART":
            ans = "活動進行中";
            break;
          case "APPLYSTART":
            ans = "開放註冊中";
            break;
          default:
            // OTHER
            break;
        }
        break;
      default:
        ans = "未知狀態";
        break;
    }
    return ans;
  }

  // 操作互動處理 //////////////////////////////////////////////

  onFinish = async (values) => {
    const { username, password } = values;
    let user_captcha = document.getElementById("user_captcha_input").value;
    if (validateCaptcha(user_captcha) === true) {
      this.props.act_login(username, password);
    } else {
      document.getElementById("user_captcha_input").value = "";
      message.info("驗證碼輸入錯誤");
      loadCaptchaEnginge(4, "purple", "white", "numbers");
    }
  };

  onFinishFailed = (errorInfo) => {
    const { errorFields } = errorInfo;
    console.log("Failed:", errorFields);
  };

  logout = () => {
    Modal.confirm({
      icon: <ExclamationCircleOutlined />,
      content: "確認要登出系統?",
      okText: "確認",
      cancelText: "取消",
      onOk: () => {
        this.props.act_logout();
        this.refresh();
      },
    });
  };

  refresh() {
    window.location.reload(false);
  }

  ////////////////////////////////////////////////////

  render() {
    const {
      isBlogger,
      links,
      clubs,
      deedsgrouped,
      licenses,
      joinactivities,
      holdactivities,
      opencourses,
      learnedcourses,
      works,
      topdeeds,
      toplicenses,
      topobjects,
      publicactivities,
      publicdeedsteacher,
      publicdeedsteachergrouped,
      publicdeedsstudent,
      publiclicensesteacher,
      publiclicensesstudent,
      BlogStatus,
      hotworks,
    } = this.state;
    const {
      BlogType,
      BannerPicFileUrl,
      FacePicFileUrl,
      DepartmentM,
      BloggerCode,
      BloggerName,
      RecordStatus,
      Cellphone,
      Email,
      Strengths,
      Description,
    } = this.state.item;
    const { userName } = this.props.user;
    const user = this.props.user;
    const errorMeg = this.props.user.error_msg;
    const objectServerUrl = "https://ccworksap.tut.edu.tw";
    const banner = BannerPicFileUrl ? BannerPicFileUrl : "";
    const bannerUrl =
      banner === ""
        ? API_BASE + "/Upload/eportfolioBanner.png"
        : API_BASE + BannerPicFileUrl;
    const headerImage = { backgroundImage: "url(" + bannerUrl + ")" };
    const imgBorderStyle = {
      borderRight: "2px solid rgba(0, 0, 0, 0.5)",
      borderBottom: "4px solid rgba(0, 0, 0, 0.8)",
    };

    // 登入後
    const listLinkItems =
      links.length > 0
        ? links.map((d, idx) => (
            <li key={idx}>
              <a key={d.ItemSortNum} href={d.LinkUrl} target="blank">
                <i className="fas fa-link"></i> {d.LinkDescription}
              </a>
            </li>
          ))
        : "";

    const listClubItems =
      clubs.length > 0
        ? clubs.map((d, idx) => (
            <li key={idx}>
              <i className="fa fa-user-circle"></i> {d.ClubName}
              {d.Position}({d.ClassroomTwName})
            </li>
          ))
        : "";
    const listLicenses =
      licenses.length > 0
        ? licenses.map((d, idx) => (
            <li key={idx} style={{ fontSize: "1.3em" }}>
              <Tag
                color={this.style_switch_color_tag(d.SubCategoryCode, "degree")}
              >
                {d.SubCategoryName}
              </Tag>
              - {d.EventTitle}
            </li>
          ))
        : "";
    const listDeeds = Object.entries(deedsgrouped).map(([deed, deeds]) => (
      <>
        <Divider orientation="left" orientationmargin={50}>
          <h3>
            <Tag
              color={this.style_switch_color_tag(deed, "deedgrouds")}
              key={deed}
              style={{ fontSize: "1.1em" }}
            >
              <i className="fas fa-angle-double-down"></i> {deed}
            </Tag>
          </h3>
        </Divider>
        {deeds.map((d, idx) => (
          <li key={idx} style={{ fontSize: "1.2em" }}>
            {d.EventTitle}
          </li>
        ))}
      </>
      // console.log(k)
    ));
    const listJoinactivities =
      joinactivities.length > 0
        ? joinactivities.map((d, idx) => (
            <li key={idx} style={{ fontSize: "1.3em" }}>
              <i className="far fa-bookmark"></i> {d.activityTitle}-
              <span style={{ fontSize: "0.7em", color: "grey" }}>
                參加時間：{formateDate(d.activityStartDate)}
              </span>
            </li>
          ))
        : "";
    const listOpencourses =
      opencourses.length > 0
        ? opencourses.map((d, idx) => (
            <li key={idx} style={{ fontSize: "1.3em" }}>
              <i className="far fa-bookmark"></i> {d.CourseType}-{d.CourseName}-
              {d.CourseTime}
            </li>
          ))
        : "";
    const listLearnedcourses =
      learnedcourses.length > 0
        ? learnedcourses.map((d, idx) => (
            <span key={idx} style={{ fontSize: "1.3em" }}>
              {" "}
              <Tag
                color={this.style_switch_color_tag(d.SelectType, "selecttype")}
              >
                {d.CourseName}
              </Tag>
            </span>
          ))
        : "";
    const listHoldactivities =
      holdactivities.length > 0
        ? holdactivities.map((d, idx) => (
            <li key={idx} style={{ fontSize: "1.3em" }}>
              <i className="far fa-bookmark"></i>{" "}
              <Tag
                color={this.style_switch_color_tag(d.timeTag, "holdactivity")}
              >
                {this.style_switch_text_tag(d.timeTag, "holdactivity")}
              </Tag>
              -{d.activityTitle}-
              <span style={{ fontSize: "0.7em", color: "Purple" }}>
                舉辦時間：{formateDate(d.activityStartDate)}
              </span>
            </li>
          ))
        : "";
    const listWorks =
      works.length > 0
        ? works.map((d, idx) => (
            <div className="col-md-6">
              <Card
                key={d.Uid}
                style={{ width: 470 }}
                cover={
                  d.ObjectVideoFilePath === "" ? (
                    <Image
                      src={
                        d.ObjectImageFilePath === ""
                          ? "https://www.salonlfc.com/wp-content/uploads/2018/01/image-not-found-scaled-1150x647.png"
                          : objectServerUrl + d.ObjectImageFilePath
                      }
                      fallback="data:image/png;base64,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"
                    />
                  ) : (
                    <VideoPlayer
                      controls={true}
                      src={API_BASE + d.ObjectVideoFilePath}
                      poster={
                        d.ObjectImageFilePath === ""
                          ? "https://www.salonlfc.com/wp-content/uploads/2018/01/image-not-found-scaled-1150x647.png"
                          : objectServerUrl + d.ObjectImageFilePath
                      }
                      width="470"
                    />
                  )
                }
                actions={[
                  <span>
                    <i className="far fa-eye"></i> {d.TotalSeenTotal}
                  </span>,
                  <span>
                    <i className="far fa-heart"></i> {d.TotalLikeTotal}
                  </span>,
                  <span>
                    <i className="fas fa-tag"></i> {d.TotalTagTotal}
                  </span>,
                  <span>
                    <i className="far fa-comment"></i> {d.TotalDiscussTotal}
                  </span>,
                ]}
              >
                <Meta
                  avatar={
                    d.CreativeCommonsLicense === "COPYRIGHT" ? (
                      <Avatar
                        shape="square"
                        size={64}
                        src="https://www.inventionpathways.com.au/wp-content/uploads/2017/09/copyright-300x300.png"
                      />
                    ) : (
                      <Avatar
                        size={64}
                        src="https://upload.wikimedia.org/wikipedia/commons/thumb/b/bd/CC-BY-NC-SA.svg/512px-CC-BY-NC-SA.svg.png"
                      />
                    )
                  }
                  title={
                    <>
                      <Divider orientation="right">
                        <Tag color="#f50">
                          <i className="fas fa-desktop"></i> {d.CategoryName}
                        </Tag>
                      </Divider>
                      名稱：{d.ObjectCollectionName}
                      <div>
                        {" "}
                        標籤：
                        {d.KeywordA === "" ? (
                          ""
                        ) : (
                          <Tag color="magenta">
                            <i className="fas fa-tag"></i> {d.KeywordA}
                          </Tag>
                        )}
                        {d.KeywordB === "" ? (
                          ""
                        ) : (
                          <Tag color="magenta">
                            <i className="fas fa-tag"></i> {d.KeywordB}
                          </Tag>
                        )}
                        {d.KeywordC === "" ? (
                          ""
                        ) : (
                          <Tag color="magenta">
                            <i className="fas fa-tag"></i> {d.KeywordC}
                          </Tag>
                        )}
                      </div>
                    </>
                  }
                  description={
                    <span
                      dangerouslySetInnerHTML={{
                        __html: d.ObjectCollectionDescription,
                      }}
                    />
                  }
                />
                <p></p>
                <p>
                  <Tag color="default">
                    {this.style_switch_text_tag(d.ObjectType, "TYPE")}
                  </Tag>
                  <span>/ </span>
                  <Tag color="default">
                    {this.style_switch_text_tag(d.IsOriginality, "ORIGINAL")}
                  </Tag>
                  <span>/ </span>
                  <Tag color="default">
                    {this.style_switch_text_tag(
                      d.CreativeCommonsLicense,
                      "LICENSE"
                    )}
                  </Tag>
                </p>
              </Card>
            </div>
          ))
        : "";

    // 登入前
    const listPublicactivities =
      publicactivities.length > 0
        ? publicactivities.map((d, idx) => (
            <li key={idx} style={{ fontSize: "1.2em" }}>
              <Tag color={this.style_switch_color_tag(d.timeTag, "timeTag")}>
                {this.style_switch_text_tag(d.timeTag, "timeTag")}
              </Tag>{" "}
              {d.activityTitle}-
              <span style={{ fontSize: "0.5em" }}>
                {d.sponsorUnit}/舉辦時間：{formateDate(d.activityStartDate)}
              </span>
            </li>
          ))
        : "";
    const listPublicdeedsteachers =
      publicdeedsteacher.length > 0
        ? Object.entries(publicdeedsteachergrouped).map(([deed, deeds]) => (
            <>
              <Divider orientation="left" orientationmargin={50}>
                <h3>
                  <Tag
                    color={this.style_switch_color_tag(deed, "deedgrouds")}
                    key={deed}
                    style={{ fontSize: "1.1em" }}
                  >
                    <i className="fas fa-angle-double-down"></i> {deed}
                  </Tag>
                </h3>
              </Divider>
              {deeds.map((d, idx) => (
                <li key={idx} style={{ fontSize: "1.2em" }}>
                  {d.EventTitle}-{" "}
                  <span style={{ fontSize: "0.5em" }}>{d.TwName}老師</span>
                </li>
              ))}
            </>
          ))
        : "";
    const listPublicdeedsstudents =
      publicdeedsstudent.length > 0
        ? publicdeedsstudent.map((d, idx) => (
            <li key={idx} style={{ fontSize: "1.2em" }}>
              <Tag
                color={this.style_switch_color_tag(d.SubCategoryCode, "deed")}
              >
                {d.SubCategoryName}
              </Tag>
              {d.EventTitle}-
              <span style={{ fontSize: "0.5em" }}>{d.TwName}同學</span>
            </li>
          ))
        : "";
    const listPubliclicensesteachers =
      publiclicensesteacher.length > 0
        ? publiclicensesteacher.map((d, idx) => (
            <li key={idx} style={{ fontSize: "1.2em" }}>
              <i
                className="fas fa-medal"
                style={{
                  color: this.style_switch_color_tag(d.Num, "awardlevel"),
                }}
              ></i>{" "}
              {d.EventTitle}
            </li>
          ))
        : "";
    const listPubliclicensesstudents =
      publiclicensesstudent.length > 0
        ? publiclicensesstudent.map((d, idx) => (
            <li key={idx} style={{ fontSize: "1.2em" }}>
              <i
                className="fas fa-medal"
                style={{
                  color: this.style_switch_color_tag(d.Num, "awardlevel"),
                }}
              ></i>{" "}
              {d.EventTitle}
            </li>
          ))
        : "";
    const listTopdeeds =
      topdeeds.length > 0
        ? topdeeds.map((d, idx) => (
            <li key={idx} style={{ fontSize: "1.2em" }}>
              <i
                className="fas fa-award"
                style={{
                  color: this.style_switch_color_tag(d.Num, "awardlevel"),
                }}
              ></i>{" "}
              {d.TwName}同學-{d.DepartmentTwName}-{d.Total}件
            </li>
          ))
        : "";
    const listToplicenses =
      toplicenses.length > 0
        ? toplicenses.map((d, idx) => (
            <li key={idx} style={{ fontSize: "1.2em" }}>
              <i
                className="fas fa-award"
                style={{
                  color: this.style_switch_color_tag(d.Num, "awardlevel"),
                }}
              ></i>{" "}
              {d.TwName}同學-{d.DepartmentTwName}-{d.Total}件
            </li>
          ))
        : "";
    const listTopobjects =
      topobjects.length > 0
        ? topobjects.map((d, idx) => (
            <li key={idx} style={{ fontSize: "1.2em" }}>
              <i
                className="fas fa-award"
                style={{
                  color: this.style_switch_color_tag(d.Num, "awardlevel"),
                }}
              ></i>{" "}
              {d.TwName}同學-{d.DepartmentTwName}-{d.Total}件
            </li>
          ))
        : "";
    const listHotWorks =
      hotworks.length > 0
        ? hotworks.map((d, idx) => (
            <div className="row">
              <Card
                key={d.Uid}
                style={{ width: 360 }}
                cover={
                  d.ObjectVideoFilePath === "" ? (
                    <Image
                      src={
                        d.ObjectImageFilePath === ""
                          ? "https://www.salonlfc.com/wp-content/uploads/2018/01/image-not-found-scaled-1150x647.png"
                          : objectServerUrl + d.ObjectImageFilePath
                      }
                      fallback="data:image/png;base64,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"
                    />
                  ) : (
                    <VideoPlayer
                      controls={true}
                      src={API_BASE + d.ObjectVideoFilePath}
                      poster={
                        d.ObjectImageFilePath === ""
                          ? "https://www.salonlfc.com/wp-content/uploads/2018/01/image-not-found-scaled-1150x647.png"
                          : objectServerUrl + d.ObjectImageFilePath
                      }
                      width="360"
                    />
                  )
                }
                actions={[
                  <span>
                    <i className="far fa-eye"></i> {d.TotalSeenTotal}
                  </span>,
                  <span>
                    <i className="far fa-heart"></i> {d.TotalLikeTotal}
                  </span>,
                  <span>
                    <i className="fas fa-tag"></i> {d.TotalTagTotal}
                  </span>,
                  <span>
                    <i className="far fa-comment"></i> {d.TotalDiscussTotal}
                  </span>,
                ]}
              >
                <Meta
                  avatar={
                    d.CreativeCommonsLicense === "COPYRIGHT" ? (
                      <Avatar
                        shape="square"
                        size={64}
                        src="https://www.inventionpathways.com.au/wp-content/uploads/2017/09/copyright-300x300.png"
                      />
                    ) : (
                      <Avatar
                        size={64}
                        src="https://upload.wikimedia.org/wikipedia/commons/thumb/b/bd/CC-BY-NC-SA.svg/512px-CC-BY-NC-SA.svg.png"
                      />
                    )
                  }
                  title={
                    <>
                      <div>
                        {" "}
                        <span>主題：</span>
                        {d.ObjectCollectionName}
                      </div>
                      <Divider orientation="right">
                        <Tag color="#f50">
                          <i className="fas fa-desktop"></i> {d.CategoryName}
                        </Tag>
                      </Divider>
                    </>
                  }
                  description={
                    <>
                      <Tag color="default">
                        {this.style_switch_text_tag(d.ObjectType, "TYPE")}
                      </Tag>
                      <span>/ </span>
                      <Tag color="default">
                        {this.style_switch_text_tag(
                          d.IsOriginality,
                          "ORIGINAL"
                        )}
                      </Tag>
                      <span>/ </span>
                      <Tag color="default">
                        {this.style_switch_text_tag(
                          d.CreativeCommonsLicense,
                          "LICENSE"
                        )}
                      </Tag>
                    </>
                  }
                />
                <p></p>
                <>
                  <span>標籤：</span>
                  {d.KeywordA === "" ? (
                    ""
                  ) : (
                    <Tag color="magenta">
                      <i className="fas fa-tag"></i> {d.KeywordA}
                    </Tag>
                  )}
                  {d.KeywordB === "" ? (
                    ""
                  ) : (
                    <Tag color="magenta">
                      <i className="fas fa-tag"></i> {d.KeywordB}
                    </Tag>
                  )}
                  {d.KeywordC === "" ? (
                    ""
                  ) : (
                    <Tag color="magenta">
                      <i className="fas fa-tag"></i> {d.KeywordC}
                    </Tag>
                  )}
                </>
              </Card>
            </div>
          ))
        : "";
    return (
      <>
        {BlogStatus === "ON" ? (
          <>
            <div className="container">
              <header className="blog-header py-3">
                <div className="row flex-nowrap justify-content-between align-items-center">
                  <div className="col-4 pt-1">
                    <span>V1.1.0</span>
                  </div>
                  <div className="col-4 text-center">
                    <Link to="/" className="blog-header-logo text-dark">
                      南應大數位歷程檔案
                    </Link>
                  </div>
                  <div className="col-4 d-flex justify-content-end align-items-center">
                    <Link
                      to="https://www.tut.edu.tw/"
                      className="btn btn-sm btn-outline-secondary"
                    >
                      台南應用科技大學
                    </Link>
                  </div>
                </div>
              </header>
              <div className="nav-scroller py-1 mb-2">
                <nav className="nav d-flex">
                  {!(user && user.token) ? (
                    <>
                      {errorMeg ? message.error(errorMeg) : null}
                      <Form
                        onFinish={this.onFinish}
                        onFinishFailed={this.onFinishFailed}
                        name="normal_form"
                        layout="inline"
                      >
                        <Item
                          name="username"
                          rules={[
                            { required: true, whitespace: true },
                            { min: 4 },
                            { pattern: /^[a-zA-Z0-9_]+$/ },
                          ]}
                        >
                          <Input
                            prefix={
                              <UserOutlined className="site-form-item-icon" />
                            }
                            placeholder={"帳號"}
                            style={{ width: "100px" }}
                          />
                        </Item>
                        <Item
                          name="password"
                          rules={[{ validator: this.validatePwd }]}
                        >
                          <Input
                            prefix={
                              <LockOutlined className="site-form-item-icon" />
                            }
                            type="password"
                            placeholder={"密碼"}
                            style={{ width: "100px" }}
                          />
                        </Item>
                        <Item>
                          <LoadCanvasTemplateNoReload />
                        </Item>
                        <Item>
                          <input
                            placeholder="驗證碼"
                            id="user_captcha_input"
                            name="user_captcha_input"
                            className="form-control input-sm"
                            style={{ width: "80px", height: "31px" }}
                            type="text"
                            maxLength="4"
                            minLength="4"
                          ></input>
                        </Item>
                        <Item>
                          <Button
                            htmlType="submit"
                            className="login-form-button"
                            type="primary"
                            danger
                          >
                            登入 <i className="fas fa-sign-in-alt"></i>
                          </Button>
                        </Item>
                      </Form>
                    </>
                  ) : (
                    <>
                      <span style={{ color: "white" }}>
                        <i className="fas fa-user-alt"></i>
                        <span style={{ marginLeft: "3px" }}>
                          {" "}
                          {userName}，您好
                        </span>
                      </span>
                      &ensp;
                      <Link to="/" target="_blank">
                        {" "}
                        <Button type="danger" size="small">
                          {" "}
                          管理{" "}
                          <i
                            style={{ marginLeft: "3px" }}
                            className="fas fa-address-card"
                          ></i>
                        </Button>
                      </Link>
                      &ensp;
                      <Button type="danger" size="small" onClick={this.logout}>
                        {" "}
                        登出{" "}
                        <i
                          style={{ marginLeft: "3px" }}
                          className="fas fa-sign-out-alt"
                        ></i>
                      </Button>
                    </>
                  )}
                </nav>
              </div>
              <div
                className="jumbotron p-4 p-md-5 text-white rounded bg-dark"
                style={headerImage}
              >
                <div className="col-md-6 px-0">
                  <h1 className="display">&ensp;</h1>
                  <h1 className="display">&ensp;</h1>
                  <h1 className="display">&ensp;</h1>
                  <h1 className="display">&ensp;</h1>
                  <h1 className="display">&ensp;</h1>
                  <h1 className="display">&ensp;</h1>
                  <h1 className="display">&ensp;</h1>
                  <h1 className="display">&ensp;</h1>
                  <h1 className="display">&ensp;</h1>
                  <h1 className="display">&ensp;</h1>
                </div>
              </div>
            </div>
            <main role="main" className="container">
              <div className="row">
                <div className="col-md-8 blog-main">
                  <Divider orientation="left" plain></Divider>
                  {isBlogger ? (
                    <>
                      {this.findConfigValue("BB") === "ON" ? (
                        <div className="blog-post">
                          <h4 className="blog-post-title">
                            <i className="far fa-address-book"></i> 個人資料
                          </h4>
                          <p className="blog-post-meta">
                            {/* <i className="fas fa-bullseye"></i>{" "}
                            關於個人生涯規劃與發展 */}
                          </p>
                          <p>
                            <span
                              dangerouslySetInnerHTML={{ __html: Description }}
                            />
                          </p>
                        </div>
                      ) : (
                        ""
                      )}
                      {this.findConfigValue("CA") === "ON" &&
                      BlogType === "TEACHER" &&
                      listOpencourses.length > 0 ? (
                        <div className="blog-post">
                          <h4 className="blog-post-title">
                            <i className="fas fa-chalkboard-teacher"></i>{" "}
                            學期開課
                          </h4>
                          <p className="blog-post-meta">
                            <i className="fas fa-bullseye"></i>{" "}
                            本學期開課相關資訊
                          </p>
                          <ol className="list-unstyled mb-0">
                            {listOpencourses}
                          </ol>
                        </div>
                      ) : (
                        ""
                      )}
                      {this.findConfigValue("DA") === "ON" &&
                      listLicenses.length > 0 ? (
                        <div className="blog-post">
                          <h4 className="blog-post-title">
                            <i className="far fa-id-card"></i>{" "}
                            {BlogType === "TEACHER" ? "學歷證照" : "證照證書"}
                          </h4>
                          <p className="blog-post-meta">
                            <i className="fas fa-bullseye"></i>{" "}
                            個人獲得之國內外學歷、證(照)書
                          </p>
                          {listLicenses}
                        </div>
                      ) : (
                        ""
                      )}
                      {this.findConfigValue("CB") === "ON" &&
                      listJoinactivities.length > 0 ? (
                        <div className="blog-post">
                          <h4 className="blog-post-title">
                            <i className="fas fa-users"></i> 活動參與
                          </h4>
                          <p className="blog-post-meta">
                            <i className="fas fa-bullseye"></i>{" "}
                            近期參與的校內活動
                          </p>
                          <ol className="list-unstyled mb-0">
                            {listJoinactivities}
                          </ol>
                        </div>
                      ) : (
                        ""
                      )}
                      {this.findConfigValue("DB") === "ON" &&
                      listDeeds.length > 0 ? (
                        <div className="blog-post">
                          <h4 className="blog-post-title">
                            <i className="fas fa-book"></i>{" "}
                            {BlogType === "TEACHER" ? "成就著作" : "優良事蹟"}
                          </h4>
                          <p className="blog-post-meta">
                            <i className="fas fa-bullseye"></i>{" "}
                            {BlogType === "TEACHER"
                              ? "個人學術期刊、論文、專書、專利、計畫案、獲獎、展演、校園及社會服務之紀錄"
                              : "個人登載在學校之獎勵紀錄"}
                          </p>
                          {listDeeds}
                        </div>
                      ) : (
                        ""
                      )}
                      {this.findConfigValue("CA") === "ON" &&
                      BlogType === "STUDENT" &&
                      listLearnedcourses.length > 0 ? (
                        <div className="blog-post">
                          <h4 className="blog-post-title">
                            <i className="fas fa-book"></i> 課程學習
                          </h4>
                          <p className="blog-post-meta">
                            <i className="fas fa-bullseye"></i>{" "}
                            在校期間已修習之課程
                          </p>
                          <div>{listLearnedcourses}</div>
                        </div>
                      ) : (
                        ""
                      )}
                      {this.findConfigValue("CC") === "ON" &&
                      BlogType === "TEACHER" &&
                      listHoldactivities.length > 0 ? (
                        <div className="blog-post">
                          <h4 className="blog-post-title">
                            <i className="far fa-calendar-alt"></i> 舉辦活動
                          </h4>
                          <p className="blog-post-meta">
                            <i className="fas fa-bullseye"></i>{" "}
                            近期個人舉辦之活動相關資訊
                          </p>
                          <ol className="list-unstyled mb-0">
                            {listHoldactivities}
                          </ol>
                          <div className="blog-post-right">
                            <span>
                              <a
                                href="https://action.tut.edu.tw/"
                                target="_black"
                              >
                                .............更多活動
                              </a>
                            </span>
                          </div>
                        </div>
                      ) : (
                        ""
                      )}
                    </>
                  ) : (
                    <>
                      <div className="blog-post">
                        <h4 className="blog-post-title">
                          <i className="far fa-calendar-alt"></i> 校園活動
                        </h4>
                        <p className="blog-post-meta">
                          <i className="fas fa-bullseye"></i>{" "}
                          可註冊或正在進行之活動資訊
                        </p>
                        <ol className="list-unstyled mb-0">
                          {listPublicactivities}
                        </ol>
                        <div className="blog-post-right">
                          <span>
                            <a
                              href="https://action.tut.edu.tw/"
                              target="_black"
                            >
                              .............更多活動
                            </a>
                          </span>
                        </div>
                      </div>
                      <div className="blog-post">
                        <h4 className="blog-post-title">
                          <i className="far fa-address-card"></i> 專業證照
                        </h4>
                        <p className="blog-post-meta">
                          <i className="fas fa-bullseye"></i>{" "}
                          統計本校師生考照登錄最多前10項證照
                        </p>
                        <Divider orientation="left" plain>
                          教職員
                        </Divider>
                        <ol className="list-unstyled mb-0">
                          {listPubliclicensesteachers}
                        </ol>
                        <Divider orientation="left" plain>
                          學生
                        </Divider>
                        <ol className="list-unstyled mb-0">
                          {listPubliclicensesstudents}
                        </ol>
                      </div>
                      <div className="blog-post">
                        <h4 className="blog-post-title">
                          <i className="fab fa-chromecast"></i> 師資著作
                        </h4>
                        <p className="blog-post-meta">
                          <i className="fas fa-bullseye"></i>{" "}
                          近期教職員之論文、展演或計畫案
                        </p>
                        <ol className="list-unstyled mb-0">
                          {listPublicdeedsteachers}
                        </ol>
                      </div>
                      <div className="blog-post">
                        <h4 className="blog-post-title">
                          <i className="fas fa-bullhorn"></i> 優良事蹟
                        </h4>
                        <p className="blog-post-meta">
                          <i className="fas fa-bullseye"></i>{" "}
                          近期學生校內外競賽表現
                        </p>
                        <ol className="list-unstyled mb-0">
                          {listPublicdeedsstudents}
                        </ol>
                      </div>
                    </>
                  )}
                </div>
                <aside className="col-md-4 blog-sidebar">
                  {isBlogger ? (
                    <>
                      <div className="p-4 mb-3 bg-light rounded">
                        <h4 className="font-italic">
                          <i className="far fa-id-badge"></i> 關於本人
                        </h4>
                        {FacePicFileUrl === "" ? (
                          ""
                        ) : (
                          <div style={{ textAlign: "center" }}>
                            <Image
                              width={180}
                              height={200}
                              src={API_BASE + FacePicFileUrl}
                              style={imgBorderStyle}
                              fallback="data:image/png;base64,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"
                            />
                          </div>
                        )}
                        {this.findConfigValue("AA") === "ON" ? (
                          <p className="mb-0">單位： {DepartmentM}</p>
                        ) : (
                          ""
                        )}
                        {this.findConfigValue("AB") === "ON" ? (
                          <p className="mb-0">
                            {BlogType === "TEACHER" ? "職號：" : "學號："}{" "}
                            {BloggerCode}
                          </p>
                        ) : (
                          ""
                        )}
                        {this.findConfigValue("AC") === "ON" ? (
                          <p className="mb-0">姓名： {BloggerName}</p>
                        ) : (
                          ""
                        )}
                        {this.findConfigValue("AD") === "ON" ? (
                          <p className="mb-0">狀態： {RecordStatus}</p>
                        ) : (
                          ""
                        )}
                        {this.findConfigValue("AE") === "ON" ? (
                          <p className="mb-0">
                            電郵：{" "}
                            <a
                              href={"mailto:" + Email}
                              target="_blank"
                              rel="noreferrer"
                            >
                              {Email}
                            </a>
                          </p>
                        ) : (
                          ""
                        )}
                        {this.findConfigValue("AF") === "ON" ? (
                          <p className="mb-0">
                            電話：{" "}
                            <a
                              href={"tel:" + Cellphone}
                              target="_blank"
                              rel="noreferrer"
                            >
                              {Cellphone}
                            </a>
                          </p>
                        ) : (
                          ""
                        )}
                      </div>
                      {this.findConfigValue("BA") === "ON" ? (
                        <div className="p-4">
                          {Strengths === null ? (
                            ""
                          ) : (
                            <h4 className="font-italic">
                              <i className="far fa-dot-circle"></i>{" "}
                              {BlogType === "TEACHER" ? "個人專長" : "興趣嗜好"}
                            </h4>
                          )}
                          {Strengths === null ? (
                            ""
                          ) : (
                            <p className="mb-0">
                              <i className="fas fa-grip-vertical"></i>{" "}
                              {Strengths}
                            </p>
                          )}
                        </div>
                      ) : (
                        ""
                      )}

                      {links.length > 0 ? (
                        <div className="p-4">
                          <h4 className="font-italic">
                            <i className="fab fa-staylinked"></i> 常用連結
                          </h4>
                          <ol className="list-unstyled mb-0">
                            {listLinkItems}
                          </ol>
                        </div>
                      ) : (
                        ""
                      )}
                      {this.findConfigValue("CC") === "ON" ? (
                        clubs.length > 0 ? (
                          <div className="p-4">
                            <h4 className="font-italic">
                              <i className="fa fa-universal-access"></i>{" "}
                              社團參與
                            </h4>
                            <ol className="list-unstyled mb-0">
                              {listClubItems}
                            </ol>
                          </div>
                        ) : (
                          ""
                        )
                      ) : (
                        ""
                      )}
                    </>
                  ) : (
                    <>
                      <div className="p-4 mb-3 bg-light rounded">
                        <h4 className="font-italic">
                          <i className="fas fa-crown"></i> 達人榜
                        </h4>
                        <Divider orientation="center">
                          <Tag color="red">學生榜區</Tag>
                        </Divider>
                        <Divider orientation="left">
                          <i className="fas fa-caret-right"></i> 專業證照
                        </Divider>
                        <ol className="list-unstyled mb-0">
                          {listToplicenses}
                        </ol>
                        <Divider orientation="left">
                          <i className="fas fa-caret-right"></i> 優良事蹟
                        </Divider>
                        <ol className="list-unstyled mb-0">{listTopdeeds}</ol>
                        <Divider orientation="left">
                          <i className="fas fa-caret-right"></i> 文創作品
                        </Divider>
                        <ol className="list-unstyled mb-0">{listTopobjects}</ol>
                      </div>
                      <div className="p-4 mb-3 bg-light rounded">
                        <h4 className="font-italic">
                          <i className="fas fa-crown"></i> 師生文創作品
                        </h4>
                        <div style={{ textAlign: "center" }}>
                          {listHotWorks}
                        </div>
                        <div
                          style={{
                            textAlign: "right",
                            marginTop: "1.5em",
                            marginBottom: "1.5em",
                            fontSize: "1.5em",
                          }}
                        >
                          <a
                            href="https://ccworksui.tut.edu.tw/album"
                            target="_black"
                            style={{ textDecoration: "underline black" }}
                          >
                            更多作品<i className="fas fa-chevron-right"></i>
                            <i className="fas fa-chevron-right"></i>
                          </a>
                        </div>
                      </div>
                    </>
                  )}
                </aside>
              </div>
            </main>
            {this.findConfigValue("DC") === "ON" && listWorks.length > 0 ? (
              <div className="container">
                <div className="blog-post">
                  <h4 className="blog-post-title">
                    <i className="far fa-closed-captioning"></i> 個人作品
                  </h4>
                  <p className="blog-post-meta">
                    <i className="fas fa-bullseye"></i> 近期在校之2D、3D文創作品
                  </p>
                </div>
                <div className="row mb-2">{listWorks}</div>
                <div
                  style={{
                    textAlign: "right",
                    marginTop: "1.5em",
                    marginBottom: "1.5em",
                    fontSize: "1.5em",
                  }}
                >
                  <a
                    href="https://ccworksui.tut.edu.tw/album"
                    target="_black"
                    style={{ textDecoration: "underline black" }}
                  >
                    更多作品<i className="fas fa-chevron-right"></i>
                    <i className="fas fa-chevron-right"></i>
                  </a>
                </div>
              </div>
            ) : (
              ""
            )}
            <footer className="blog-footer">
              <p>
                Copyright &copy; 2022{" "}
                <a
                  href="https://www.tut.edu.tw/"
                  target="_blank"
                  rel="noreferrer"
                >
                  台南應用科技大學 Tainan University of Technology
                </a>
              </p>
              <p>
                校址：710302台南市永康區中正路529號 No.529, Zhongzheng Rd.,
                Yongkang District, Tainan City 710302, Taiwan (R.O.C.)
              </p>
              <p>│ 電話：+886-6-2532106 │ 傳真：+886-6-2540702</p>
              <p>│ 系統設計：網路與資訊中心 曾秋榮先生 分機 #261</p>
              <BackTop>
                <div className="goTop" style={{ color: "green" }}>
                  <i className="fas fa-arrow-circle-up"></i>
                </div>
              </BackTop>
            </footer>
          </>
        ) : (
          <div>
            <Alert message="此個人歷程檔案已關閉" type="error" showIcon />
          </div>
        )}
      </>
    );
  }
}

export default connect((state) => ({ user: state.user }), {
  act_login,
  act_logout,
})(Blog);
